module.exports = __webpack_public_path__ + "img/x-octagon-fill.6d956463.svg";